import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import InboxIcon from '@material-ui/icons/Inbox';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
}));


const CompTema = ({ tema, index, setTemaSelected, temaSelected, setTema, setTemaId }) => {

    const classes = useStyles();

    React.useEffect(() => {
        setTema(tema);
        setTemaId(tema.id)
        setTemaSelected(index);
    }, []);

    const seleccionarTema =() => {
        setTema(tema);
        setTemaId(tema.id)
        setTemaSelected(index);
    }

    let tituloTema = tema.tituloTema;

    return (
        <div className={classes.root}>
            <List component="nav" aria-label="main mailbox folders">
                <ListItem
                    button
                    selected={temaSelected === index}
                    // onClick={(event) => handleListItemClick(event, 0)}
                    onClick={() => seleccionarTema()}
                >
                    <ListItemIcon>
                        <InboxIcon />
                    </ListItemIcon>
                    <ListItemText primary={tituloTema} />
                </ListItem>
                <Divider />
            </List>

        </div>
    );

}

export default CompTema
